// 8 個固定順序的類別色（CVD-safe），順序本身就是安全機制，不可任意打亂或循環使用。
// 來源：dataviz skill 的 reference palette（light surface）。
export const CATEGORICAL_COLORS = [
  "#2a78d6", // blue
  "#1baf7a", // aqua
  "#eda100", // yellow
  "#008300", // green
  "#4a3aa7", // violet
  "#e34948", // red
  "#e87ba4", // magenta
  "#eb6834", // orange
];

export const OTHER_COLOR = "#898781"; // muted ink，代表被折疊進「其他」的類別

export const SEQUENTIAL_BLUE = "#2a78d6";

export const STATUS_GOOD = "#0ca30c";
export const STATUS_CRITICAL = "#d03b3b";

export const TEXT_PRIMARY = "#0b0b0b";
export const TEXT_SECONDARY = "#52514e";
export const TEXT_MUTED = "#898781";
export const GRIDLINE = "#e1e0d9";
export const SURFACE = "#fcfcfb";

const MAX_CATEGORICAL_SLOTS = CATEGORICAL_COLORS.length;

// 依 id 排序決定固定的顏色順序（id 不會變，同一類別在任何圖表、任何時候都是同色）。
// 第 9 個以後的類別沒有安全色可用，一律用 muted 灰 — 這些長條仍各自有文字標籤，
// 識別靠標籤而不是顏色。傳入的 categoryIds 允許重複（會先去重）。
export function assignCategoryColors(categoryIds) {
  const colorById = {};
  const sortedIds = [...new Set(categoryIds)].sort((a, b) => Number(a) - Number(b));

  sortedIds.forEach((id, index) => {
    colorById[id] = index < MAX_CATEGORICAL_SLOTS ? CATEGORICAL_COLORS[index] : OTHER_COLOR;
  });

  return colorById;
}
